import React from "react";
import PropTypes from "prop-types";

// Assets
import logo from "assets/images/oi-logo.svg";

// Components
import ServerErrorModal from "components/Modals/ServerError/ServerError";
import Portal from "components/Portal/Portal";

export default function FullPageWithHeader(props) {
  return (
    <div className="layout layout-full-page-with-header">
      <Portal>
        <ServerErrorModal />
      </Portal>
      <header>
        <span>
          <img src={logo} alt="Octopus Investments" />
        </span>
      </header>
      <section className="container">{props.children}</section>
    </div>
  );
}

FullPageWithHeader.propTypes = {
  children: PropTypes.node.isRequired,
};
